<template>
  <v-card
    :color="random_rgba()"
    dark
    >
        <div class="d-flex flex-no-wrap justify-space-between">

            <div>
            <v-card-title
                class="headline"
                v-text="title"
            ></v-card-title>

            <v-card-subtitle>
                <div>
                    {{description}}
                </div>
                <div class="visualizationClass">
                    {{accessCounter + " click since " + creationDate + " • last click " + lastAccess + " • " + avgdayusage + " click/day" + (avgdayusage == 0 ? " • 😢" : "")}}                     
                </div>
            </v-card-subtitle>

            <v-card-actions>

                <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                
                    <v-btn
                    @click="clickHandler(id)"
                    class="ml-2 mt-5"
                    outlined
                    rounded
                    small
                    v-on="on"
                    v-bind="attrs"
                    >
                    <v-icon
                    >mdi-open-in-new</v-icon>
                    </v-btn>

                </template>
                <span>{{'go to ' + title}}</span>
                </v-tooltip>
            </v-card-actions>
            </div>

            <v-avatar
            class="ma-3"
            size="100"
            tile
            >
            <v-img :src="imageurl"></v-img>
            </v-avatar>

        </div>
    </v-card>
</template>

<script>

import{
    increaseAccessCountById
} from "@/constants/graphql.js";

export default {

    props:[
        "title",
        "description",
        "imageurl",
        "id",
        "accessCounter",
        "lastAccess",
        "creationDate",
        "avgdayusage"
    ],

    methods:{
        random_rgba() {
            var o = Math.round, r = Math.random, s = 255;
            //return 'rgba(' + o(r()*s) + ',' + o(r()*s) + ',' + o(r()*s) + ',' + r().toFixed(1) + ')';
            return 'rgba(' + o(r()*s) + ',' + o(180) + ',' + o(r()*s) + ',' + 1 + ')';
        },

        random_hex(){
            return '#' + Math.floor(Math.random()*16777215).toString(16);
        },

        //Click handler
        clickHandler(id){

            //Increase access count
            this.$apollo.mutate({
                mutation: increaseAccessCountById,
                variables:{
                    id: id 
                }
            }).then((data) => {
                //Only if success open window
                window.open(data.data.increaseAccessCount.url, "_blank")
            }).catch((error) => {
                console.log(error)
            });

            
        }

    }   

}
</script>

<style scoped>

.avatarClass{
    background-size: contain;
}

.visualizationClass{
    display: flex;
    font-size: small;
}

</style>